import { jwtConfig } from '../settings';

const customHeader = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: 'Bearer ' + localStorage.getItem('id_token') || undefined,
});

const base = (method, url, data = null, replaceHeader = null) => {
  const header = replaceHeader == null ? customHeader() : replaceHeader;
  
  const init = {
    method,
    headers: header,
  };
  
  if(data !== null) init.body = JSON.stringify(data);
  
  return fetch(`${jwtConfig.fetchUrl}${url}`, init)
    .then(r =>  r.json().then(data => ({status: r.status, data})))
    .then(obj => (obj))
    .catch(error => ({ error: error }));
};

const SuperFetch = {};
['get', 'post', 'put', 'PATCH', 'delete'].forEach(method => {
  SuperFetch[method] = base.bind(null, method);
});
export default SuperFetch;
